import { FC, Fragment, useState } from 'react';

import { Link, Text, TextList, VSpacing } from '@hh.ru/magritte-ui';
import { ChevronDownOutlinedSize16, ChevronUpOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

const REQUIREMENTS = [
    {
        title: 'AdCreate.AdForm.BannerImg.technicalRequirements.general.title',
        items: [
            'AdCreate.AdForm.BannerImg.technicalRequirements.general.item1.magritte',
            'AdCreate.AdForm.BannerImg.technicalRequirements.general.item2',
            'AdCreate.AdForm.BannerImg.technicalRequirements.general.item3',
            'AdCreate.AdForm.BannerImg.technicalRequirements.general.item4.magritte',
        ],
    },
    {
        title: 'AdCreate.AdForm.BannerImg.technicalRequirements.additional.title',
        items: [
            'AdCreate.AdForm.BannerImg.technicalRequirements.additional.item1.magritte',
            'AdCreate.AdForm.BannerImg.technicalRequirements.additional.item2',
            'AdCreate.AdForm.BannerImg.technicalRequirements.additional.item3',
            'AdCreate.AdForm.BannerImg.technicalRequirements.additional.item4',
        ],
    },
];

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerImg.technicalRequirements.general.titleMagritte',
};

export const TechnicalRequirements: FC = () => {
    const [isOpen, setOpen] = useState(false);

    const trl = useTrls();

    return (
        <>
            <Link
                Element="button"
                onClick={() => setOpen(!isOpen)}
                iconRight={isOpen ? <ChevronUpOutlinedSize16 /> : <ChevronDownOutlinedSize16 />}
            >
                {trl(TrlKeys.title)}
            </Link>
            {isOpen && (
                <>
                    <VSpacing default={12} />
                    {REQUIREMENTS.map(({ title, items }, i) => (
                        <Fragment key={title}>
                            <Text typography="subtitle-1-semibold">{trl(title)}</Text>
                            <VSpacing default={12} />
                            <TextList Element="ul">
                                {items.map((item) => (
                                    <Text key={item}>{trl(item)}</Text>
                                ))}
                            </TextList>
                            {i === 0 && <VSpacing default={12} />}
                        </Fragment>
                    ))}
                </>
            )}
        </>
    );
};
